import script from "./StudentExamTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentExamTable.vue?vue&type=script&setup=true&lang=js"

import "./StudentExamTable.vue?vue&type=style&index=0&id=45ca8cab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ca8cab"]])

export default __exports__